function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-1110.5 -418.5)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1",
  "data-name": "Rectangle 1",
  width: 68,
  height: 68,
  transform: "translate(1110.5 418.5)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Mail_Icon",
  "data-name": "Mail Icon",
  transform: "translate(1114.5 429.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_1",
  "data-name": "Fill 1",
  d: "M49.7,1.321A4.793,4.793,0,0,0,46.3,0H4.7A4.792,4.792,0,0,0,1.3,1.321,4.764,4.764,0,0,0,0,4.7V7.382a2.013,2.013,0,1,0,4.026.057V4.7c0-.395.079-.5.125-.545s.145-.126.546-.126H46.3c.4,0,.5.079.545.126s.126.15.126.545V9.37s0,0,0,0,0,.014,0,.021V28.855c0,.395-.08.478-.126.524s-.145.147-.545.147H44.961a2.013,2.013,0,1,0-.057,4.026h1.4a4.491,4.491,0,0,0,4.7-4.7V4.7a4.766,4.766,0,0,0-1.3-3.376",
  transform: "translate(9 0)",
  fill: "#dfdfdf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill_4",
  "data-name": "Fill 4",
  d: "M46.3,34H4.7a4.761,4.761,0,0,1-3.4-1.339A4.887,4.887,0,0,1,0,29.24V4.76A4.887,4.887,0,0,1,1.3,1.339,4.761,4.761,0,0,1,4.7,0H46.3a4.761,4.761,0,0,1,3.4,1.339A4.884,4.884,0,0,1,51,4.76V29.24a4.884,4.884,0,0,1-1.3,3.421A4.761,4.761,0,0,1,46.3,34ZM4.026,5.8V29.24c0,.4.079.482.126.531s.146.149.545.149H46.3c.4,0,.5-.1.545-.148s.126-.126.126-.531V5.8L28.73,19.975a5.271,5.271,0,0,1-6.459,0ZM25.5,17c.147,0,.246.005.311.008l.086,0c.073,0,.089-.015.157-.079a3.032,3.032,0,0,1,.244-.209L42.57,4.08H8.43L24.7,16.724a3.029,3.029,0,0,1,.244.209c.068.064.084.079.156.079l.085,0C25.254,17.005,25.353,17,25.5,17Z",
  transform: "translate(0 11)",
  fill: "#dfdfdf"
})));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.9cb9ca2c.svg";
export { ForwardRef as ReactComponent };